import { featureManager } from "./feature-manager";
import { firebaseFeatureProvider } from "./providers";

// Currently we already receives the user feature in the login response, so we can skip this provider for now unless needed later to be live
// featureManager.registerProvider(userFeatureProvider);
featureManager.registerProvider(firebaseFeatureProvider);

// for now disable feature manager as we need to make sure the backend API works
featureManager.init();
